import type { Locale } from '@pba/utils';

export const appLanguageCodes = ['en', 'es'] as const;

export type AppLanguage = (typeof appLanguageCodes)[number];

export const locales: Record<AppLanguage, Locale> = {
  en: 'en-US',
  es: 'es-ES',
};
